
<template>
	<div>
		<v-layout row wrap>
			<v-flex sm12>
				<v-flex text-xs-left xs12>
					<div>
						<div
							style="border-left-color: lightgray; padding-left: 10px; padding-right: 10px;">
							<table>
								<tr>
									<td>
										<p>
											Question: {{ discussionItem.item.item }}
										</p>
										<p>
											Answer: &nbsp;
											<span v-if="discussionItem.employeeItem.item.rankType == 0 && discussionItem.employeeItem.comment" class="text-xs-left comment-text">
												{{ discussionItem.employeeItem.comment }}
											</span>
											<v-btn v-else class="response-btn item-btn disabled" :class="getClass(discussionItem.employeeItem.result)" fab small>
												<v-icon	v-if="discussionItem.employeeItem.result != '-1' && discussionItem.employeeItem.item.rankType == 1" style="font-size: 14px;">
													{{ getIcon(discussionItem.employeeItem.result) }}
												</v-icon>
												<v-icon	v-if="discussionItem.employeeItem.result != '-1' && discussionItem.employeeItem.item.rankType == 2" style="font-size: 25px;">
													{{ getHappyIcon(discussionItem.employeeItem.result) }}
												</v-icon>
											</v-btn>
										</p>
									</td>
								</tr>
							</table>
						</div>
					</div>
				</v-flex>
			</v-flex>
		</v-layout>
		<v-divider style="margin-bottom:20px;"></v-divider>
	</div>
</template>

<script>
import avatarMixin from '@/mixins/avatarMixin';

export default {
	props: {
		discussionItem: {
			required: true,
			type: Object
		},
		employee: {
			required: true,
			type: Object
		},
	},
	data() {
		return {
			form: {
				notes: this.discussionItem.notes
			}
		};
	},
	mixins: [avatarMixin],
	methods: {
		getClass(result) {
			switch(result) {
				case 0:
					return 'error';
				case 1:
					return 'warning';
				case 2:
					return 'success';
			}
		},
		getIcon(result) {
			switch (result) {
				case -1:
					return 'radio_button_unchecked';
					break;
				case 0:
					return 'clear';
					break;
				case 1:
					return 'remove';
					break;
				case 2:
					return 'check';
					break;
				default:
					return 'keyboard_arrow_right';
					break;
			}
		},
		getHappyIcon(result) {
			switch (result) {
				case 0:
					return 'mdi-emoticon-cry-outline';
					break;
				case 1:
					return 'mdi-emoticon-sad-outline';
					break;
				case 2:
					return 'mdi-emoticon-neutral-outline';
					break;
				case 3:
					return 'mdi-emoticon-happy-outline';
					break;
				case 4:
					return 'mdi-emoticon-outline';
					break;
				default:
					return 'keyboard_arrow_right';
					break;
			}
		}
	}
};
</script>

<style scoped>
	.comment-text {
		font-style: italic;
		height: inherit;
	}

	.response-btn {
		margin: 0px;
		vertical-align: sub;
	}
</style>
